/* Conventional*/
import { ReactComponent as transactionConventional } from "../../assets/icons/conventional/transaction.svg";
import { ReactComponent as availabilityConventional } from "../../assets/icons/conventional/availability.svg";
import { ReactComponent as balanceConventional } from "../../assets/icons/conventional/balance.svg";
import { ReactComponent as managerConventional } from "../../assets/icons/conventional/manager.svg";
import { ReactComponent as plusConventional } from "../../assets/icons/conventional/rak-value-plus.svg";
import { ReactComponent as maxConventional } from "../../assets/icons/conventional/rak-value-max.svg";
import { ReactComponent as interrogationConventional } from "../../assets/icons/conventional/interrogation.svg";
import { ReactComponent as signatureConventional } from "../../assets/icons/conventional/signature.svg";
import { ReactComponent as licenseConventional } from "../../assets/icons/conventional/trade-license.svg";
import { ReactComponent as passportConventional } from "../../assets/icons/conventional/passport-visa.svg";
import { ReactComponent as emiratesIdConventional } from "../../assets/icons/conventional/emirates-id.svg";
import { ReactComponent as bankingClockConventional } from "../../assets/icons/conventional/bankingClock.svg";
import { ReactComponent as companyDocumentsConventional } from "../../assets/icons/conventional/company-documents.svg";
import { ReactComponent as bankingConventional } from "../../assets/icons/conventional/banking.svg";
import { ReactComponent as logoConventional } from "../../assets/images/logo.svg";
import overviewConventoinal from "../../assets/gif/overview_reg.gif";
import paperPlaneRegular from "../../assets/gif/paperplane_regular.gif";
import submittedRegular from "../../assets/gif/submitted_regular.gif";
import successRegular from "../../assets/gif/submitted_regular.gif";
import notFoundRegular from "../../assets/gif/declined_regular.gif";

/* RAKIslamic */
import { ReactComponent as balanceIslamic } from "../../assets/icons/islamic/balance.svg";
import { ReactComponent as availabilityIslamic } from "../../assets/icons/islamic/availability.svg";
import { ReactComponent as processingIslamic } from "../../assets/icons/islamic/processing.svg";
import { ReactComponent as transactionIslamic } from "../../assets/icons/islamic/transaction.svg";
import { ReactComponent as managerIslamic } from "../../assets/icons/islamic/manager.svg";
import { ReactComponent as withdrawalIslamic } from "../../assets/icons/islamic/withdrawal.svg";
import { ReactComponent as serviceCenterIslamic } from "../../assets/icons/islamic/serviceCenter.svg";
import { ReactComponent as exchangeIslamic } from "../../assets/icons/islamic/exchange.svg";
import { ReactComponent as plusIslamic } from "../../assets/icons/islamic/rak-value-plus.svg";
import { ReactComponent as maxIslamic } from "../../assets/icons/islamic/rak-value-max.svg";
import { ReactComponent as loungeIslamic } from "../../assets/icons/islamic/lounge.svg";
import { ReactComponent as interrogationIslamic } from "../../assets/icons/islamic/interrogation.svg";
import { ReactComponent as signatureIslamic } from "../../assets/icons/islamic/signature.svg";
import { ReactComponent as licenseIslamic } from "../../assets/icons/islamic/trade-license.svg";
import { ReactComponent as passportIslamic } from "../../assets/icons/islamic/passport-visa.svg";
import { ReactComponent as emiratesIdIslamic } from "../../assets/icons/islamic/emirates-id.svg";
import { ReactComponent as companyDocumentsIslamic } from "../../assets/icons/islamic/company-documents.svg";
import { ReactComponent as bankingIslamic } from "../../assets/icons/islamic/banking.svg";
import { ReactComponent as logoIslamic } from "../../assets/images/islamicLogo.svg";
import { ReactComponent as bankingClockIslamic } from "../../assets/icons/islamic/bankingClockIslamic.svg";
import overviewIslamic from "../../assets/gif/overview_islamic.gif";
import paperPlaneIslamic from "../../assets/gif/paperplane_islamic.gif";
import submittedIslamic from "../../assets/gif/submitted_islamic.gif";
import successIslamic from "../../assets/gif/success_islamic.gif";
import notFoundIslamic from "../../assets/gif/declined_islamic.gif";

/* RAKElite */
import { ReactComponent as processingEliteIc } from "../../assets/icons/elite/processing.svg";
import { ReactComponent as withdrawalElite } from "../../assets/icons/elite/withdrawal.svg";
import { ReactComponent as managerElite } from "../../assets/icons/elite/manager.svg";
import { ReactComponent as serviceCenterElite } from "../../assets/icons/elite/serviceCenter.svg";
import { ReactComponent as exchangeElite } from "../../assets/icons/elite/exchange.svg";
import { ReactComponent as plusElite } from "../../assets/icons/elite/rak-value-plus.svg";
import { ReactComponent as maxElite } from "../../assets/icons/elite/rak-value-max.svg";
import { ReactComponent as loungeElite } from "../../assets/icons/elite/lounge.svg";
import { ReactComponent as interrogationElite } from "../../assets/icons/elite/interrogation.svg";
import { ReactComponent as signatureElite } from "../../assets/icons/elite/signature.svg";
import { ReactComponent as licenseElite } from "../../assets/icons/elite/trade-license.svg";
import { ReactComponent as passportElite } from "../../assets/icons/elite/passport-visa.svg";
import { ReactComponent as emiratesIdElite } from "../../assets/icons/elite/emirates-id.svg";
import { ReactComponent as companyDocumentsElite } from "../../assets/icons/elite/company-documents.svg";
import { ReactComponent as bankingElite } from "../../assets/icons/elite/banking.svg";
import { ReactComponent as logoElite } from "../../assets/images/eliteConvLogo.svg";
import { ReactComponent as bankingClockElite } from "../../assets/icons/elite/bankingClockElite.svg";
import overviewElite from "../../assets/gif/overview_elite.gif";
import paperPlaneElite from "../../assets/gif/paperplane_elite.gif";
import submittedElite from "../../assets/gif/submitted_elite.gif";
import successElite from "../../assets/gif/success_elite.gif";
import notFoundElite from "../../assets/gif/declined_elite.gif";

/*RakElite Islamic*/
import overviewEliteIslamic from "../../assets/gif/overview_elite islamic.gif";

export const conventionalIconsSet = {
  availability: availabilityConventional,
  balance: balanceConventional,
  transaction: transactionConventional,
  manager: managerConventional,
  plus: plusConventional,
  max: maxConventional,
  interrogation: interrogationConventional,
  signature: signatureConventional,
  license: licenseConventional,
  passport: passportConventional,
  emiratesId: emiratesIdConventional,
  companyDocuments: companyDocumentsConventional,
  banking: bankingConventional,
  logo: logoConventional,
  overview: overviewConventoinal,
  awaiting: paperPlaneRegular,
  submitted: submittedRegular,
  success: successRegular,
  bankingClock: bankingClockConventional,
  notFound: notFoundRegular
};

export const islamicIconsSet = {
  availability: availabilityIslamic,
  balance: balanceIslamic,
  processing: processingIslamic,
  transaction: transactionIslamic,
  manager: managerIslamic,
  withdrawal: withdrawalIslamic,
  serviceCenter: serviceCenterIslamic,
  exchange: exchangeIslamic,
  plus: plusIslamic,
  max: maxIslamic,
  lounge: loungeIslamic,
  interrogation: interrogationIslamic,
  signature: signatureIslamic,
  license: licenseIslamic,
  passport: passportIslamic,
  emiratesId: emiratesIdIslamic,
  companyDocuments: companyDocumentsIslamic,
  banking: bankingIslamic,
  logo: logoIslamic,
  overview: overviewIslamic,
  awaiting: paperPlaneIslamic,
  submitted: submittedIslamic,
  success: successIslamic,
  bankingClock: bankingClockIslamic,
  notFound: notFoundIslamic
};

export const eliteIconsSet = {
  balance: balanceIslamic,
  processing: processingEliteIc,
  withdrawal: withdrawalElite,
  manager: managerElite,
  serviceCenter: serviceCenterElite,
  exchange: exchangeElite,
  lounge: loungeElite,
  plus: plusElite,
  max: maxElite,
  interrogation: interrogationElite,
  signature: signatureElite,
  license: licenseElite,
  passport: passportElite,
  emiratesId: emiratesIdElite,
  companyDocuments: companyDocumentsElite,
  banking: bankingElite,
  logo: logoElite,
  overview: overviewElite,
  awaiting: paperPlaneElite,
  submitted: submittedElite,
  success: successElite,
  bankingClock: bankingClockElite,
  notFound: notFoundElite
};

export const eliteIslamicIconsSet = {
  ...eliteIconsSet,
  overview: overviewEliteIslamic
};
